import { HOC_MDXWrapper } from 'nextra/setup-page'
import { pageMap } from '/vercel/path0/website/.next/static/chunks/nextra-page-map-.mjs'
/*@jsxRuntime automatic*/
/*@jsxImportSource react*/
import {useMDXComponents as _provideComponents} from "nextra/mdx";
const title = "React hooks";
const frontMatter = {};
import {Callout} from 'nextra/components';
import {TypeScriptIcon} from "nextra/icons";
export function useTOC(props) {
  return [{
    value: "useObservable()",
    id: "useobservable",
    depth: 2
  }, {
    value: "useObservableEvent()",
    id: "useobservableevent",
    depth: 2
  }];
}
function MDXLayout(props) {
  const {toc = useTOC(props)} = props;
  const _components = {
    code: "code",
    h1: "h1",
    h2: "h2",
    p: "p",
    pre: "pre",
    span: "span",
    strong: "strong",
    ..._provideComponents(),
    ...props.components
  };
  return <><_components.h1>{"React hooks"}</_components.h1>{"\n"}<_components.h2 id={toc[0].id}>{toc[0].value}</_components.h2>{"\n"}<_components.p>{"A React hook that returns the current/latest value from an observable"}</_components.p>{"\n"}<_components.p><_components.strong>{"Signature"}</_components.strong></_components.p>{"\n"}<_components.pre icon={TypeScriptIcon} tabIndex="0" data-language="ts" data-word-wrap="" data-copy=""><_components.code><_components.span><_components.span style={{
    "--shiki-light": "#D73A49",
    "--shiki-dark": "#F97583"
  }}>{"function"}</_components.span><_components.span style={{
    "--shiki-light": "#6F42C1",
    "--shiki-dark": "#B392F0"
  }}>{" useObservable"}</_components.span><_components.span style={{
    "--shiki-light": "#24292E",
    "--shiki-dark": "#E1E4E8"
  }}>{"<"}</_components.span><_components.span style={{
    "--shiki-light": "#6F42C1",
    "--shiki-dark": "#B392F0"
  }}>{"T"}</_components.span><_components.span style={{
    "--shiki-light": "#24292E",
    "--shiki-dark": "#E1E4E8"
  }}>{">("}</_components.span><_components.span style={{
    "--shiki-light": "#E36209",
    "--shiki-dark": "#FFAB70"
  }}>{"observable$"}</_components.span><_components.span style={{
    "--shiki-light": "#D73A49",
    "--shiki-dark": "#F97583"
  }}>{":"}</_components.span><_components.span style={{
    "--shiki-light": "#6F42C1",
    "--shiki-dark": "#B392F0"
  }}>{" Observable"}</_components.span><_components.span style={{
    "--shiki-light": "#24292E",
    "--shiki-dark": "#E1E4E8"
  }}>{"<"}</_components.span><_components.span style={{
    "--shiki-light": "#6F42C1",
    "--shiki-dark": "#B392F0"
  }}>{"T"}</_components.span><_components.span style={{
    "--shiki-light": "#24292E",
    "--shiki-dark": "#E1E4E8"
  }}>{">)"}</_components.span><_components.span style={{
    "--shiki-light": "#D73A49",
    "--shiki-dark": "#F97583"
  }}>{":"}</_components.span><_components.span style={{
    "--shiki-light": "#6F42C1",
    "--shiki-dark": "#B392F0"
  }}>{" T"}</_components.span><_components.span style={{
    "--shiki-light": "#D73A49",
    "--shiki-dark": "#F97583"
  }}>{" |"}</_components.span><_components.span style={{
    "--shiki-light": "#005CC5",
    "--shiki-dark": "#79B8FF"
  }}>{" null"}</_components.span></_components.span>{"\n"}<_components.span><_components.span style={{
    "--shiki-light": "#D73A49",
    "--shiki-dark": "#F97583"
  }}>{"function"}</_components.span><_components.span style={{
    "--shiki-light": "#6F42C1",
    "--shiki-dark": "#B392F0"
  }}>{" useObservable"}</_components.span><_components.span style={{
    "--shiki-light": "#24292E",
    "--shiki-dark": "#E1E4E8"
  }}>{"<"}</_components.span><_components.span style={{
    "--shiki-light": "#6F42C1",
    "--shiki-dark": "#B392F0"
  }}>{"T"}</_components.span><_components.span style={{
    "--shiki-light": "#24292E",
    "--shiki-dark": "#E1E4E8"
  }}>{">("}</_components.span></_components.span>{"\n"}<_components.span><_components.span style={{
    "--shiki-light": "#E36209",
    "--shiki-dark": "#FFAB70"
  }}>{"  observable$"}</_components.span><_components.span style={{
    "--shiki-light": "#D73A49",
    "--shiki-dark": "#F97583"
  }}>{":"}</_components.span><_components.span style={{
    "--shiki-light": "#6F42C1",
    "--shiki-dark": "#B392F0"
  }}>{" Observable"}</_components.span><_components.span style={{
    "--shiki-light": "#24292E",
    "--shiki-dark": "#E1E4E8"
  }}>{"<"}</_components.span><_components.span style={{
    "--shiki-light": "#6F42C1",
    "--shiki-dark": "#B392F0"
  }}>{"T"}</_components.span><_components.span style={{
    "--shiki-light": "#24292E",
    "--shiki-dark": "#E1E4E8"
  }}>{">,"}</_components.span></_components.span>{"\n"}<_components.span><_components.span style={{
    "--shiki-light": "#E36209",
    "--shiki-dark": "#FFAB70"
  }}>{"  initialValue"}</_components.span><_components.span style={{
    "--shiki-light": "#D73A49",
    "--shiki-dark": "#F97583"
  }}>{":"}</_components.span><_components.span style={{
    "--shiki-light": "#6F42C1",
    "--shiki-dark": "#B392F0"
  }}>{" T"}</_components.span><_components.span style={{
    "--shiki-light": "#D73A49",
    "--shiki-dark": "#F97583"
  }}>{" |"}</_components.span><_components.span style={{
    "--shiki-light": "#005CC5",
    "--shiki-dark": "#79B8FF"
  }}>{" undefined"}</_components.span><_components.span style={{
    "--shiki-light": "#24292E",
    "--shiki-dark": "#E1E4E8"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span><_components.span style={{
    "--shiki-light": "#E36209",
    "--shiki-dark": "#FFAB70"
  }}>{"  options"}</_components.span><_components.span style={{
    "--shiki-light": "#D73A49",
    "--shiki-dark": "#F97583"
  }}>{"?:"}</_components.span><_components.span style={{
    "--shiki-light": "#6F42C1",
    "--shiki-dark": "#B392F0"
  }}>{" UseObservableOptions"}</_components.span><_components.span style={{
    "--shiki-light": "#24292E",
    "--shiki-dark": "#E1E4E8"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span><_components.span style={{
    "--shiki-light": "#24292E",
    "--shiki-dark": "#E1E4E8"
  }}>{")"}</_components.span><_components.span style={{
    "--shiki-light": "#D73A49",
    "--shiki-dark": "#F97583"
  }}>{":"}</_components.span><_components.span style={{
    "--shiki-light": "#6F42C1",
    "--shiki-dark": "#B392F0"
  }}>{" T"}</_components.span></_components.span>{"\n"}<_components.span>{" "}</_components.span>{"\n"}<_components.span><_components.span style={{
    "--shiki-light": "#D73A49",
    "--shiki-dark": "#F97583"
  }}>{"interface"}</_components.span><_components.span style={{
    "--shiki-light": "#6F42C1",
    "--shiki-dark": "#B392F0"
  }}>{" UseObservableOptions"}</_components.span><_components.span style={{
    "--shiki-light": "#24292E",
    "--shiki-dark": "#E1E4E8"
  }}>{" {"}</_components.span></_components.span>{"\n"}<_components.span><_components.span style={{
    "--shiki-light": "#E36209",
    "--shiki-dark": "#FFAB70"
  }}>{"  disabled"}</_components.span><_components.span style={{
    "--shiki-light": "#D73A49",
    "--shiki-dark": "#F97583"
  }}>{"?:"}</_components.span><_components.span style={{
    "--shiki-light": "#005CC5",
    "--shiki-dark": "#79B8FF"
  }}>{" boolean"}</_components.span></_components.span>{"\n"}<_components.span><_components.span style={{
    "--shiki-light": "#24292E",
    "--shiki-dark": "#E1E4E8"
  }}>{"}"}</_components.span></_components.span></_components.code></_components.pre>{"\n"}<_components.h2 id={toc[1].id}>{toc[1].value}</_components.h2>{"\n"}<Callout emoji="🚨">{"This page is a stub. Help us expand it by contributing!"}</Callout></>;
}


export default HOC_MDXWrapper(
  MDXLayout,
  '/reference',
  {"filePath":"src/pages/reference.mdx","timestamp":1758550271000,pageMap,frontMatter,title},
  typeof RemoteContent === 'undefined' ? useTOC : RemoteContent.useTOC
)